
import React, { useState, useEffect, useMemo } from 'react';
import { history, useIntl } from 'umi';


export const tableConfig={
        MobileGameList: {
          OperationData: {
            title: 'dbi_detail_trend',
          },
          GamesData: {
            title: 'dbi_genre_profile_top_games',
            subSegment: [
              { text: 'dbi_revenue_$', value: 'revenue'},
              { text: 'dbi_downloads', value: 'downloads'},
              { text: 'MAU', value: 'MAU'},
            ],

          },
          GanresData: {
            title: 'dbi_market_top_genre',
            // text: 'Sorted by data.ai Revenue($)',
            subSegment: [
              { text: 'dbi_revenue_$', value: 'revenue' },
              { text: 'dbi_downloads', value: 'downloads' },
            ],
          },
          CompaniesData: {
            title: 'dbi_genre_profile_top_companies',
            // text: 'Sorted by data.ai Revenue($)',
            subSegment: [
              { text: 'dbi_revenue_$', value: 'revenue' },
              { text: 'dbi_downloads', value: 'downloads' },
            ],
          },
        },
        PCGameList: {
          OperationData: {
            title: 'dbi_detail_trend',
          },
          GamesData: {
            title: 'dbi_genre_profile_top_games',
            // text: 'Sorted by Digital Revenue ($)',
            subSegment: [
              { text: 'dbi_metric_digitalRevenue', value: 'revenue' },
              { text: 'dbi_metric_physical_revenue', value: 'revenueP' },
              { text: 'dbi_mau', value: 'MAU' },
            ],
          },
          GanresData: {
            title: 'dbi_market_top_genre',
            // text: 'Sorted by data.ai Revenue($)',
          },
          CompaniesData: {
            title: 'dbi_genre_profile_top_companies',
            // text: 'Sorted by data.ai Revenue($)',
          },
        },
        ConsoleGameList: {
          OperationData: {
            title: 'dbi_detail_trend',
          },
          GamesData: {
            title: 'dbi_genre_profile_top_games',
            // text: 'Sorted by data.ai Revenue($)',
            subSegment: [
              { text: 'dbi_metric_digitalRevenue', value: 'revenue' },
              { text: 'dbi_metric_physical_revenue', value: 'revenueP' },
              { text: 'dbi_mau', value: 'MAU' },
            ],
          },
          GanresData: {
            title: 'dbi_market_top_genre',
            // text: 'Sorted by data.ai Revenue($)',
          },
          CompaniesData: {
            title: 'dbi_genre_profile_top_companies',
            // text: 'Sorted by data.ai Revenue($)',
          },
        },
}